import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

import { DeleteAccount } from './DeleteAccount';
import { NoticeScreen } from './NoticeScreen';

/**
 * The client app's `/me/privacy` (§6, open item 14.6).
 *
 * §5 lists `GET /me/consents`, `POST /me/consents/{purpose}/withdraw` and `POST /me/dsr`,
 * and **all three are blocked on BP-04's client login**: there is no way today to tell
 * which client a browser is, and guessing is exactly what DPDP §6 forbids. §14.6 ruled the
 * answer — "stub copy 'ask at front desk' until BP-04" — so this screen says that, in one
 * sentence, above the notice the client is entitled to read without signing in at all.
 *
 * When BP-04 lands, the copy is replaced by the consent list and the two buttons; the
 * notice below it stays exactly as it is.
 *
 * **`DeleteAccount` is not part of that stub.** BP-11 R17 is a store
 * requirement with its own api route (`/me/erase`), and it is on this screen
 * because this is the client app's privacy screen — the place both stores'
 * reviewers will look for it, and the place the listings point at.
 */
export function MePrivacyScreen(): JSX.Element {
  const { t } = useTranslation('dpdp');

  return (
    <div className="space-y-4" data-testid="me-privacy">
      <section className="rounded bg-muted p-3">
        <h2 className="font-semibold">{t('dpdp.privacy.frontDeskTitle')}</h2>
        <p className="text-sm text-foreground">{t('dpdp.privacy.frontDesk')}</p>
      </section>
      <DeleteAccount />
      <NoticeScreen />
    </div>
  );
}
